import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from "./citizens-services-sector.graphql";
import * as fromActions from "./citizens-services-sector.actions"
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';


@Injectable()
export class CitizensServicesSectorEffects {

  citizenGetAllSectors$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetAllSectors),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_CITIZEN_SECTOR,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching citizen Service All Sector'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensServicesSectors({citizensServicesSectors: result?.data})) : []
          }
        })
      );
    })
  ), {dispatch: false});

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {
  }
}
